import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { useSearchParams } from 'react-router-dom'
import { LinearProgress } from '@mui/material'
import { H3 } from '../../../layouts/TextStyles'
import { courseApiSlice } from '../../../features/course/courseSlice'
import AnalyticsTable from './components/AnalyticsTable'

const AnalyticsPage = () => {
    const { formatMessage } = useIntl()
    const [searchParams, setSearchParams] = useSearchParams('')
    const [page, setPage] = React.useState(+searchParams.get('page') || 1)
    const [rowsPerPage, setRowsPerPage] = React.useState(
        +searchParams.get('size') || 5,
    )
    const {
        data: analyticsResponse = null,
        isFetching,
    } = courseApiSlice.useFetchAnalyticsQuery({
        page: +page - 1,
        size: +rowsPerPage,
    })

    useEffect(() => {
        const params = {
            page: page.toString(),
            size: rowsPerPage.toString(),
        }
        setSearchParams(params)
    }, [rowsPerPage, page])

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3> {formatMessage({ id: 'courseAnalytic' })} </H3>
                    </Title>
                </Header>

                {isFetching ? (
                    <LinearProgress />
                ) : (
                    analyticsResponse && (
                        <AnalyticsTable
                            isFetching={isFetching}
                            analyticsData={analyticsResponse?.data}
                            pageNumber={analyticsResponse?.pageNumber}
                            totalCount={analyticsResponse?.totalCount}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            setPage={setPage}
                            setRowsPerPage={setRowsPerPage}
                        />
                    )
                )}
            </Content>
        </Wrapper>
    )
}

export default AnalyticsPage


const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`

const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: #fff;
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`